import { ref, type Ref } from 'vue';
import type { User } from '@/types';

/**
 * Module-level auth state, kept outside Pinia so the axios instance can read it
 * without importing a store — the stores themselves import axios, and Pinia
 * would otherwise close a circular dependency at module-evaluation time.
 */
export const currentUser: Ref<User | null> = ref(null);
export const isLoggingOut: Ref<boolean> = ref(false);
export const appReady: Ref<boolean> = ref(false);

export function setCurrentUser(user: User | null): void {
    currentUser.value = user;
}

export function setLoggingOut(value: boolean): void {
    isLoggingOut.value = value;
}

export function setAppReady(value: boolean): void {
    appReady.value = value;
}
